import { render } from "./AssessmentSelection.vue?vue&type=template&id=d0579c0e"
import script from "./AssessmentSelection.vue?vue&type=script&lang=js"
export * from "./AssessmentSelection.vue?vue&type=script&lang=js"
script.render = render

export default script